// extracted by mini-css-extract-plugin
export default {"container":"index_container__Yiuih","followProductWrapper":"index_followProductWrapper__NHmsI"};